module.exports = __webpack_public_path__ + "static/media/revisiones.30604fd1.png";